import { cart } from "./cart";
import { cartModal} from "./cartModal";

export default {
    cart,
    cartModal,
}
